export const UserPasswordValidators = {
  count: (v) => v.length >= 4 || "Password must be at least 4 characters",
  hasLetter: (v) => /[A-Za-z]/.test(v) || "Password must include a letter",
  whiteSpace: (v) => /^\S*$/.test(v) || "White spaces are not allowed",
  hasOnlyAllowedSpecials: (v) =>
    !/[^\w!,.?@-]+/.test(v) ||
    "Password cannot include special characters other than @!?,.-_",
};
